<template>
  <div class="info">
    <!-- <el-table
      border
      v-loading="loading"
      v-horizontal-scroll="'always'"
      :column="columns"
      :data="list"
      pagination
      :total="page.totalNum"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[5, 10, 20, 30, 50]"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      @size-change="handleSizeChange"
      @p-current-change="handleCurrentChange"
    >
    </el-table> -->
    <el-table
      :data="page.list"
      style="width: 100%"
      :header-cell-style="{
        'text-align': 'center',
        background: '#F8F8F9',
        color: '#333333',
      }"
    >
      <el-table-column prop="createTime" label="时间" width="200">
      </el-table-column>
      <el-table-column prop="orderNo" label="订单编号" width="220">
      </el-table-column>
      <el-table-column prop="address" label="商品">
        <template slot-scope="scope">
          <div
            v-for="(item, index) in scope.row.goodsInfoList"
            :key="index"
            style="text-align: left"
          >
            <div
              style="
                width: 100%;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                text-overflow: ellipsis;
                overflow: hidden;
              "
            >
              {{ item.goodsName }}
            </div>
            <div>{{ item.skuName }}*{{ item.num }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="typeLabel" label="类型" width="200">
      </el-table-column>
      <el-table-column prop="num" label="积分金额" width="200">
        <template slot-scope="scope">
          {{ Number(scope.row.num).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="statusLabel" label="状态" width="200">
      </el-table-column>
    </el-table>
    <div style="float: right; margin-top: 20px">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.currentPage"
        :page-sizes="[5, 10, 20, 30, 50]"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalNum"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import LbTable from '../../../components/lb-table/lb-table'
export default {
  props: {
    phone: {
      type: String,
      default: ''
    },
  },
  components: {
    LbTable
  },
  data () {
    return {
      name: 'cdd',
      list: [{
        name: 'cdd',
        goodsInfoList: [
          {
            goodsName: 'gsdfgsdjgfjsdgfjsdgfjashjgfs'
          },
          {
            goodsName: 'cddddddddddddd'
          }, {
            goodsName: 'cddddddddddd'
          }
        ]
      },

      ],
      columns: [
        { label: '时间', prop: 'createTime', minWidth: '120' },
        { label: '订单编号', prop: 'orderNo', minWidth: '220' },
        {
          label: '商品', prop: 'goodsInfoList', minWidth: '120',
          // render: (h, scope) => {
          //   let arr = scope.row.goodsInfoList
          //   return (
          //     <div></div>
          //   )
          // }
        },
        { label: '类型', prop: 'typeLabel', minWidth: '120' },
        {
          label: '积分金额', prop: 'num', minWidth: '120',
          render: (h, scope) => {
            return (
              <div> {Number(scope.row.num).toFixed(2)}</div>
            )
          }
        },
        { label: '状态', prop: 'statusLabel', minWidth: '120' }
      ],
      page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      loading: false
    }
  },
  watch: {
    phone (val, vall) {
      this.phone = val
    },
  },
  created () {
    this.fetchData()
  },
  methods: {
    handleCurrentChange (currentChange) {
      this.page.pageNo = currentChange
      this.fetchData()
    },
    handleSizeChange (sizeChange) {
      this.page.pageSize = sizeChange
      this.fetchData()
    },
    fetchData () {
      let data = {
        phone: this.phone,
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize
      }
      this.$api.matrixServerGetPointsList(data).then(res => {
        this.page.list = res.data.list
        this.page.totalNum = res.data.totalNum
        this.loading = false
      })
    }
  }
}
</script>
<style scoped>
.info {
  padding-top: 20px;
  padding-bottom: 70px;
}
</style>

